// AboutCard.jsx
import React from "react";

const AboutCard = ({ image, name, role, description }) => {
  return (
    <div className="flex flex-col md:flex-row items-center bg-surface text-body border border-border shadow-md rounded-2xl overflow-hidden">
      <img
        src={image}
        alt={name}
        className="w-full md:w-1/3 h-auto object-cover md:rounded-l-2xl"
      />
      <div className="p-6 space-y-2 text-center md:text-left">
        <h2 className="text-2xl font-semibold text-accent-1">{name}</h2>
        <h3 className="text-lg text-accent-2">{role}</h3>
        <p className="text-base leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default AboutCard;
